import { useEffect, useCallback } from "react";
import { useParameter, useFavouriteProviderContext } from "../../../shared";

import { useSlideTitle } from "../hooks/useSlideTitle";

export function useFavourite() {
  const title = useSlideTitle();
  const {
    state: { isFavouriteLoading },
    actions: { setParameters, setApplyFunction },
  } = useFavouriteProviderContext();

  const [business, setBusiness] = useParameter<number>("@business-units");
  const [commodities, setCommodities] = useParameter<number[]>("@commodities");
  const [commoditiesGroup, setCommoditiesGroup] = useParameter<number[]>("@commodities_groups");

  useEffect(() => {
    setParameters(title, {
      "@business-units": business,
      "@commodities": commodities,
      "@commodities_groups": commoditiesGroup,
    });
  }, [title, business, commodities, commoditiesGroup, setParameters]);

  const applyParameters = useCallback(
    (parameters: Record<string, string[]>) => {
      setBusiness(parameters["@business-units"].map(Number)[0]);
      setCommodities(parameters["@commodities"].map(Number));
      setCommoditiesGroup(parameters["@commodities_groups"].map(Number));
    },
    [setBusiness, setCommodities, setCommoditiesGroup]
  );

  useEffect(() => {
    setApplyFunction(applyParameters);
  }, [setApplyFunction, applyParameters]);

  return { isFavouriteLoading };
}
